// Place in theme.liquid before </body> or your main theme JS bundle
(function () {
  const TARGET_SELECTORS = [
    // Wrapper that Fly Bundles hides
    '.product-form__item.product-form__item--submit.product-form__item--payment-button',
    // The actual ATC button
    'button.product-form__cart-submit[data-fly-bundles-atc-btn="true"]',
    // Payment button wrapper
    '.shopify-payment-button',
    // (Optional) quantity row if Fly Bundles hides it too
    '.product-form__quantity'
  ];

  function unhideEls() {
    // 1) Remove inline display:none!important
    document.querySelectorAll(TARGET_SELECTORS.join(',')).forEach(el => {
      if (el.hasAttribute('style')) {
        // Remove only display property so we don't blow away other inline styles
        el.style.removeProperty('display');
        // If style becomes empty, drop the attribute
        if (!el.getAttribute('style') || el.getAttribute('style').trim() === '') {
          el.removeAttribute('style');
        }
      }
      // 2) Clear Fly Bundles’ data “hide” flag on the wrapper
      if (el.matches('.product-form__item--submit')) {
        el.removeAttribute('data-fly-bundles-atc-btn-hidden');
      }
    });

    // 3) Remove any injected <style> that hides our targets
    const killer = Array.from(document.querySelectorAll('style')).find(s =>
      /\.(product-form__quantity|shopify-payment-button|product-form__buttons\s+button)\s*{[^}]*display\s*:\s*none\s*!important/i
        .test(s.textContent)
    );
    if (killer) killer.remove();
  }

  // MutationObserver: run when Fly Bundles injects/changes the product form area
  const productRoot =
    document.querySelector('.product-form, form[action*="/cart/add"]') || document.body;

  const obs = new MutationObserver((mutations) => {
    // Trigger when we see the data flags or inline display:none appear
    const changed = mutations.some(m => {
      if (m.type === 'attributes' && m.attributeName === 'style') {
        const t = m.target;
        return t && (t.matches(TARGET_SELECTORS.join(',')));
      }
      if (m.type === 'attributes' && m.attributeName && m.attributeName.startsWith('data-')) {
        return (m.target && m.target.matches('.product-form__item--submit'));
      }
      if (m.type === 'childList') {
        return Array.from(m.addedNodes || []).some(n =>
          n.nodeType === 1 && (
            n.matches?.(TARGET_SELECTORS.join(',')) ||
            n.querySelector?.(TARGET_SELECTORS.join(','))
          )
        );
      }
      return false;
    });

    if (changed) unhideEls();
  });

  obs.observe(productRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['style','data-fly-bundles-atc-btn-hidden'] });

  // Safety passes for slow injections or SPA navigations
  document.addEventListener('DOMContentLoaded', unhideEls);
  window.addEventListener('load', unhideEls);
  setTimeout(unhideEls, 800);
  setTimeout(unhideEls, 2000);
  setTimeout(unhideEls, 4000);

  // Optional: if your theme fires a variant change event, re-run
  document.addEventListener('variant:change', unhideEls, { passive: true });
})();
